export default __webpack_public_path__ + "static/ringintensive-4b6635538bc931354a87b51d38d373a3.png";